/**
 * 图片上传服务
 * 复用 estha-web 的 Azure Blob SAS 直传模式。
 */
import { BlobServiceClient } from '@azure/storage-blob';
import { api, API_PATHS } from './client';

const AZURE_ACCOUNT_NAME = 'esthatest';
const AZURE_CONTAINER_NAME = 'estha';

export type SettingsImageField = 'logo' | 'banner';

interface AzureSASData {
  sas: string;
}

export async function getAzureSAS(): Promise<AzureSASData> {
  return api.post<AzureSASData>(API_PATHS.TOOL_AZURE_CREATE_SAS);
}

function sanitizeFileName(fileName: string): string {
  const sanitized = fileName
    .trim()
    .replace(/[^a-zA-Z0-9._-]/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');

  return sanitized || 'image';
}

export async function uploadSettingsImage(
  file: File,
  field: SettingsImageField
): Promise<string> {
  const { sas } = await getAzureSAS();
  const blobServiceClient = new BlobServiceClient(
    `https://${AZURE_ACCOUNT_NAME}.blob.core.windows.net?${sas}`
  );
  const containerClient = blobServiceClient.getContainerClient(AZURE_CONTAINER_NAME);
  const blobName = `myorg-settings/${field}/${Date.now()}-${sanitizeFileName(file.name)}`;
  const blockBlobClient = containerClient.getBlockBlobClient(blobName);

  await blockBlobClient.uploadData(file, {
    blobHTTPHeaders: {
      blobContentType: file.type || 'application/octet-stream',
    },
  });

  return blockBlobClient.url.split('?')[0];
}
